import ZkSvgIcon from './src/main'
ZkSvgIcon.install = function (Vue) {
  Vue.component(ZkSvgIcon.name, ZkSvgIcon)
}
export default ZkSvgIcon



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/svg/index.js